module.exports = __webpack_public_path__ + "static/assets/4b6100c9f591be6470cdfd4697de0b54.svg";